<template>
  <div class="row">
    <div class="col-md-8">
      <b-button
        squared
        class="mb-2"
        size="sm"
        variant="primary"
        @click="btnPrintOnClick"
        >Download PDF (Invoice)</b-button
      >

      <Print :data="data" :setting="setting" />

      <br />
      <br />

      <b-button
        squared
        class="d-block mb-2"
        size="sm"
        variant="primary"
        @click="btnPrint2OnClick"
        >Download PDF (Lembar Tanda Terima)</b-button
      >
      <PrintInvoiceReceipt :data="data" :setting="setting" />
    </div>

    <!-- PDF -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="`${data.po_no}-${data.vendor_name}`"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <Print :data="data" />
      </section>
    </vue-html2pdf>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="`${data.po_no}-${data.vendor_name}`"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfReceipt"
    >
      <section slot="pdf-content">
        <PrintInvoiceReceipt :data="data" />
      </section>
    </vue-html2pdf>

    <div class="col-md">
      <!-- <b-button
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="info"
        @click="btnPrintOnClick"
        >Download PDF</b-button
      > -->
      <b-button
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="success"
        v-if="manipulateBtn == true"
        @click="$router.push('/purchase-orders/edit/' + data.id)"
        >Edit Invoice (Surat Faktur)</b-button
      >
      <b-button
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="success"
        v-if="manipulateBtn == true"
        @click="$router.push('/purchase-orders/add')"
        >Tambah Baru</b-button
      >
    </div>
  </div>
</template>

<style>
.section-to-keep-together {
  page-break-inside: avoid;
  break-inside: avoid;
}
</style>

<script>
import Print from "@/component/purchase-orders/Print.vue";
import PrintInvoiceReceipt from "@/component/purchase-orders/PrintInvoiceReceipt.vue";
import module from "@/core/modules/CrudModule.js";
import VueHtml2pdf from "vue-html2pdf";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import html2pdf from "html2pdf.js";

export default {
  components: {
    Print,
    PrintInvoiceReceipt,
    VueHtml2pdf,
  },

  data() {
    return {
      // Data
      data: {},
      setting: {},
      manipulateBtn: false,
    };
  },

  methods: {
    async getSetting() {
      this.setting = await module.get("website-settings/get-default");
      if (this.setting == null) {
        this.setting = {
          address:
            "Jl. Kramat 6 No.11, RT.2/RW.1, Kenari, Kec. Senen, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10430",
          emergency: "(021) 3909333",
        };
      }
      console.log("setting", this.setting);
    },

    async get() {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      this.data = await module.get(`purchase-orders/${this.$route.params.id}`);
      let data = new Date(this.data.date);
      let localdata = new Date(this.data.date).toLocaleDateString(
        "id-ID",
        options
      );

      this.data.date = localdata.split(",")[1];
      console.log("natural", data);
      console.log("local", localdata.split(",")[1]);
      // If Data Not found
      if (this.data == null) {
        // Redirect To List
        this.$router.push("/purchase-orders");
      }
    },

    async btnPrintOnClick() {
      const el = document.getElementById("print-lab-report");
      if (!el) return;

      // cari elemen signature image
      const signatureImg = el.querySelector(".signature img");
      console.log("signatureImg", signatureImg);

      if (signatureImg && !signatureImg.src.startsWith("data:")) {
        try {
          let endpoint = process.env.VUE_APP_API_ENDPOINT;
          endpoint = endpoint.replace(/\/api\/?$/, "/");
          if (!endpoint.endsWith("/")) endpoint += "/";
          // ubah src jadi lewat proxy backend kamu
          const proxyUrl = `${endpoint}proxy-image?url=${encodeURIComponent(
            signatureImg.src
          )}`;
          signatureImg.setAttribute("crossorigin", "anonymous");
          signatureImg.src = proxyUrl;

          console.log("original src:", signatureImg.src);
          console.log("proxy url:", proxyUrl);
          console.log("endpoint:", endpoint);

          console.log("✔ Signature redirected via proxy:", proxyUrl);

          // kecilkan delay dikit supaya sempat load sebelum di-convert PDF
          await new Promise((resolve) => {
            signatureImg.onload = () => resolve();
            setTimeout(resolve, 1000); // fallback 1 detik kalau onload gak terpanggil
          });
        } catch (err) {
          console.error("❌ Gagal load signature via proxy:", err);
        }
      }

      // opsi html2pdf
      const opt = {
        margin: [10, 10, 10, 10], // atas, kiri, bawah, kanan (mm)
        filename: `Invoice-${this.data.po_no}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true, // penting agar gambar cross-domain bisa diambil
          allowTaint: true,
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"] },
      };

      await html2pdf().set(opt).from(el).save();
    },

    btnPrint2OnClick() {
      // this.$htmlToPaper("print-invoice-receipt");

      const el = document.getElementById("print-invoice-receipt");

      const opt = {
        margin: [10, 10, 10, 10], // atas, kiri, bawah, kanan (mm)
        filename: "Lembar-Tanda-Terima-${data.po_no}.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 }, // kualitas tinggi
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf().set(opt).from(el).save();
    },

    btnDownloadOnClick() {
      this.$refs.html2Pdf.generatePdf();
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        // console.log("looping")

        if (access_right[a] == "6022") {
          this.manipulateBtn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Invoice (Surat Faktur)", route: "/purchase-orders" },
      { title: "Detail" },
    ]);
    // Get Data
    this.get();
    this.getSetting();
    this.setActiveMenu();
  },
};
</script>

<style>
</style>